module.exports = __webpack_public_path__ + "static/media/live25_10_2019.ff9d70d2.jpg";